<template>
    <b-card no-body>
        <b-modal id="shipment-order-detail-modal" title="Sipariş Detayları" size="lg" scrollable hide-footer v-on:hidden="clearForm">
            <shipment-order-detail-view :item="selectedItem" />
        </b-modal>
        <b-modal id="shipment-picking-modal" title="Sevkiyat Ürün Toplama" size="xl" hide-footer scrollable>
            <shipment-picking-view v-if="selectedItem.FISNO" :order="selectedItem" :all-balances="allBalances" @ship-items="executeShipment" />
        </b-modal>
        <v-table ref="table" :items-provider="orderProvider" :fields="fields" :buttons="buttons" pagination="client">
            <template #filters>
                <div class="row align-items-end">
                    <div class="col-md-4">
                        <b-form-group label="Müşteri Kodu">
                            <b-form-input v-model="filters.CariKodu" @keyup.enter="search" placeholder="Müşteri koduna göre ara..." />
                        </b-form-group>
                    </div>
                    <div class="col-md-4">
                        <b-form-group label="Sipariş Numarası">
                            <b-form-input v-model="filters.SiparisNo" @keyup.enter="search" placeholder="Sipariş numarasına göre ara..." />
                        </b-form-group>
                    </div>
                    <div class="col-md-1"></div>
                    <div class="col-md-3">
                        <b-form-group label="">
                            <div class="d-flex w-100">
                                <button type="button" class="btn btn-secondary w-100 mr-1" v-on:click="clearFilters">Temizle</button>
                                <button type="button" class="btn btn-primary w-100" v-on:click="search">Ara</button>
                            </div>
                        </b-form-group>
                    </div>
                </div>
            </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard, BFormGroup, BFormInput } from "bootstrap-vue";
import { WarehouseApi } from "@/api/warehouse/index.js";
import ShipmentOrderDetailView from "./components/ShipmentOrderDetailView.vue";
import ShipmentPickingView from "./components/ShipmentPickingView.vue";

export default {
    name: "ShipmentTransferView",
    components: { BCard, BFormGroup, BFormInput, ShipmentOrderDetailView, ShipmentPickingView },

    data() {
        return {
            selectedItem: {},
            allBalances: [],
            filters: { CariKodu: "", FaturaNo: "" },
            fields: [
                { key: "FISNO", name: "Sipariş No", thClass: "w-25" },
                { key: "CARI_UNVAN", name: "Müşteri Ünvanı", thClass: "w-50" },
                { key: "STHAR_TARIH_FORMATTED", name: "Tarih", thClass: "w-15" },
                { key: "KalemAdedi", name: "Kalem Adedi", thClass: "w-10" },
            ],
            buttons: [
                { key: "shipment", icon: "ArrowLeftCircleIcon", variant: "warning", text: "Sevkiyat Başlat", action: this.startShipmentProcess },
                { key: "detail", icon: "EyeIcon", variant: "info", text: "Detay", action: this.showDetailModal },
            ],
        };
    },
    methods: {
        showDetailModal(item) {
            this.selectedItem = item;
            this.$bvModal.show("shipment-order-detail-modal");
        },
        clearForm() {
            this.selectedItem = {};
        },
        search() {
            this.$refs.table.refresh();
        },
        async orderProvider() {
            this.$refs.table.setLoading(true);
            try {
                const [ordersResponse, balancesResponse] = await Promise.all([WarehouseApi.getSalesOrders(this.filters), WarehouseApi.getListCellBalance({ StockCode: "" })]);

                const flatItems = ordersResponse.data.Data || [];
                this.allBalances = balancesResponse.data.Data || [];

                const groupedByFisno = flatItems.reduce((acc, item) => {
                    if (!acc[item.FISNO]) {
                        acc[item.FISNO] = { ...item, Kalemler: [] };
                    }
                    acc[item.FISNO].Kalemler.push(item);
                    return acc;
                }, {});

                const tableItems = Object.values(groupedByFisno).map((order) => ({
                    ...order,
                    KalemAdedi: order.Kalemler.length,
                    FormattedTarih: new Date(order.STHAR_TARIH).toLocaleDateString("tr-TR"),
                }));

                this.$refs.table.setItems(tableItems);
                this.$refs.table.setTotal(tableItems.length);
            } catch (error) {
                this.$result(null, error);
                this.$refs.table.setItems([]);
                this.$refs.table.setTotal(0);
            } finally {
                this.$refs.table.setLoading(false);
            }
        },
        startShipmentProcess(item) {
            this.selectedItem = item;
            this.$bvModal.show("shipment-picking-modal");
        },
        executeShipment(shipmentItems) {
            this.$refs.table.rowLoading(true);
            this.$bvModal.hide("shipment-picking-modal");

            const payload = shipmentItems.map((item) => ({
                ...item,
                CellTransferType: 3,
            }));

            WarehouseApi.insertCellTransfer(payload)
                .then((res) => {
                    this.$result(res);
                    if (res.data.Success) {
                        this.search();
                    }
                })
                .catch((err) => this.$result(null, err))
                .finally(() => {
                    this.$refs.table.rowLoading(false);
                });
        },
        clearFilters() {
            this.filters = { CariKodu: "", FaturaNo: "" };
            this.search();
        },
    },
};
</script>
